module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-icons/home-improvement.svg?d90c92c3f300ee07b9607438e1121092";